const PREVISUALISATION = {
  titlePopUp: 'Vos modifications en prévisualisation n\'ont pas été validées',
  actions: {
    previsualiser: 'Prévisualiser',
    editPrev: 'Editer',
    cancel: 'Annuler',
    saveWithoutNewPrevisualisation: 'Sauvegarder sans',
    saveWithNewPrevisualisation: 'Sauvegarder avec',
  },
  textInfo: 'Positionner votre souris sur l’élément du tableau que vous souhaitez masquer ou afficher.',
  infoPrev: {
    title: 'Vous ne pouvez pas accéder à la prévisualisation',
    payeur: 'Vous devez avoir au moins un payeur',
    destinataireComptable: 'Vous devez avoir au moins un destinataire comptable',
    ligneCommande: 'Vous devez avoir au moins une ligne de vente',
  },
  info: {
    textInfo: 'Pour éditer votre {typeDCF}, cliquer sur le bouton « Editer » à droite de votre {typeDCF} puis passer votre souris sur la ligne que vous souhaitez modifier, choisissez les lignes à afficher / masquer.',
    titleInfo: 'Comment éditer {typeDcf} ?',
    typeDcf: {
      devis: 'devis',
      commande: 'commande',
      facture: 'facture',
      monDevis: 'devis',
      maFacture: 'ma facture',
      maCommande: 'ma commande',
    },
  },
  texteEditionSignatureTitle: 'Signature',
  texteEditionSignature: 'Texte inséré avant signature',
};

export default PREVISUALISATION;
